import clsx from 'clsx'
import VideoCard from '../VideoCard'

export default function VideoGrid({
  localVideoTrack,
  localAudioTrack,
  remoteVideoTrack,
  remoteAudioTrack,
  localParticipant,
  remoteParticipant,
  localMuted,
  remoteMuted,
  localSpeaking,
  remoteSpeaking,
  className,
  participants = [], // Array of all participants for dynamic layout
}) {
  // Calculate participant count for dynamic grid layout
  const participantCount = Math.max(2, participants.length || (localVideoTrack ? 1 : 0) + (remoteVideoTrack ? 1 : 0))
  
  // Create participants array if not provided
  const allParticipants = participants.length > 0 ? participants : [
    { 
      videoTrack: localVideoTrack, 
      audioTrack: localAudioTrack, 
      participant: localParticipant, 
      isMuted: localMuted, 
      isSpeaking: localSpeaking,
      isLocal: true
    },
    { 
      videoTrack: remoteVideoTrack, 
      audioTrack: remoteAudioTrack, 
      participant: remoteParticipant, 
      isMuted: remoteMuted, 
      isSpeaking: remoteSpeaking,
      isLocal: false
    }
  ].filter(p => p.participant) // Only include participants that exist

  return (
    <div
      className={clsx(
        'video-grid w-full h-full',
        // Mobile responsive
        'max-md:fixed max-md:top-[60px] max-md:left-0 max-md:right-0 max-md:bottom-[70px]',
        'max-md:p-1 max-md:max-h-none max-md:h-[calc(100vh-130px)] max-md:overflow-hidden',
        className
      )}
      data-participants={allParticipants.length}
    >
      {/* Render all participants dynamically */}
      {allParticipants.map((participant, index) => (
        <VideoCard
          key={participant.isLocal ? 'local' : `remote-${index}`}
          videoTrack={participant.videoTrack}
          audioTrack={participant.audioTrack}
          participant={participant.participant}
          isMuted={participant.isMuted}
          isSpeaking={participant.isSpeaking}
          placeholder={
            !participant.videoTrack
              ? { 
                  icon: participant.isLocal ? '📹' : '👤', 
                  text: participant.isLocal ? 'Requesting camera access...' : 'Waiting for participant...' 
                }
              : null
          }
          className={clsx(
            // Mobile: Keep as part of grid layout
            'max-md:relative max-md:w-full max-md:h-full',
            'max-md:rounded-xl',
            'max-md:shadow-[0_4px_12px_rgba(0,0,0,0.5)]'
          )}
        />
      ))}
    </div>
  )
}
